export const cohortBuilderInfoBarMessagesEn = {
  'projects.cohortBuilderPage.components.cohortInfoBar.dataset': 'Dataset',
  'projects.cohortBuilderPage.components.cohortInfoBar.labelType': 'Type',
  'projects.cohortBuilderPage.components.cohortInfoBar.typeCohort': 'Cohort',
  'projects.cohortBuilderPage.components.cohortInfoBar.labelOwner': 'Owner',
  'projects.cohortBuilderPage.components.cohortInfoBar.labelLastModified': 'Last modified',
  'projects.cohortBuilderPage.components.cohortInfoBar.unknownOwner': 'Unknown',
  'projects.cohortBuilderPage.components.cohortInfoBar.subjects': 'Subjects',
};
